

export const filterDecisions = async (filters) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      let result = [];
      
      if (filters.search) {
        const query = filters.search.toLowerCase();
        result = result.filter(d => 
          (d.horse && d.horse.name.toLowerCase().includes(query)) ||
          (d.handler && d.handler.name.toLowerCase().includes(query)) ||
          (d.show && d.show.name.toLowerCase().includes(query))
        );
      }
      
      if (filters.reason && filters.reason !== 'All Reasons') {
        result = result.filter(d => d.reason.toLowerCase() === filters.reason.toLowerCase());
      }
      
      if (filters.year && filters.year !== 'All Years') {
        result = result.filter(d => d.decisionDate.startsWith(filters.year));
      }

      const totalCount = result.length;

      // Pagination
      if (filters.skip !== undefined && filters.take !== undefined) {
        result = result.slice(filters.skip, filters.skip + filters.take);
      }

      resolve({
        totalCount,
        result
      });
    }, 500); // Simulate network delay
  });
};

export const getDecisionById = async (id) => {
  // return new Promise((resolve) => {
  //   setTimeout(() => {
  //     const decision = MOCK_DECISIONS.find(d => d.id === id);
  //     resolve(decision || null);
  //   }, 300);
  // });
};
